module.exports = __webpack_public_path__ + "static/media/professores.f0b96ba1.png";